import React from 'react';

type props = {
  status: any;
  initialstatus?: boolean;
  id: string;
  disabled?: boolean;
  setStatus: (data: any) => void;
};

const ToggleButton: React.FunctionComponent<props> = ({ status, setStatus, id, disabled }): JSX.Element => {
  const randomid = Math.random().toString();

  return (
    <div>
      <div className="grid grid-cols-1 gap-0">
        <div className="duration-400 relative mr-2 inline-block w-16 select-none align-middle transition ease-in">
          <input
            type="checkbox"
            id={randomid}
            className={
              'absolute block cursor-pointer appearance-none rounded-full focus:ring-transparent ' +
              (!status
                ? 'h-8 w-8 border-4 border-gray-300 bg-white'
                : 'toggle-button stacked-bar-green-primary h-6 w-6') +
              ' ' +
              'toggle-checkbox'
            }
            checked={status}
            onChange={(e) => !disabled && setStatus(e.target.checked)}
          />
          <label
            htmlFor={randomid}
            className={
              'block h-8 cursor-pointer overflow-hidden rounded-full ' +
              (!status ? ' bg-gray-300' : ' toggle-back-ground') +
              ' ' +
              (disabled ? ' cursor-not-allowed' : '')
            }
          >
            <span
              className={
                (status ? 'float-left ' : 'float-right ') +
                (disabled ? ' cursor-not-allowed' : '') +
                ' px-2 py-1 font-extrabold'
              }
            ></span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default ToggleButton;
